// services/feedbackService.js
import { collection, getDocs, query, where, orderBy } from "firebase/firestore";
import { db } from "../firebase";
import { getApiUrl } from "../utils/apiConfig";

export const feedbackService = {
  // Submit new feedback using backend API
  async submitFeedback(feedbackData) {
    try {
      const response = await fetch(getApiUrl('/admin/feedback'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          ...feedbackData,
          createdAt: new Date().toISOString(),
          status: "new",
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      return result;
    } catch (error) {
      console.error("Error submitting feedback:", error);
      throw error;
    }
  },

  // Get all feedback (for admin)
  async getAllFeedback() {
    try {
      const q = query(
        collection(db, "feedback"),
        orderBy("createdAt", "desc"),
      );
      
      const snapshot = await getDocs(q);
      return snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data(),
      }));
    } catch (error) {
      console.error("Error fetching feedback:", error);
      throw error;
    }
  },

  // Get feedback by user
  async getUserFeedback(userId) {
    try {
      const q = query(
        collection(db, "feedback"),
        where("userId", "==", userId),
        orderBy("createdAt", "desc"),
      );
      
      const snapshot = await getDocs(q);
      return snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data(),
      }));
    } catch (error) {
      console.error("Error fetching user feedback:", error);
      throw error;
    }
  },
};